import DomPurify from 'dompurify';
import * as Yup from 'yup';
import { TemplateFormNameFieldMeta } from '../interfaces/template-form-name-field-meta';
import { TemplateFormNameField } from '../TemplateFormNameField';
import { TemplateFormComponentMeta } from '../../../interfaces/template-form-component-meta';

export const TemplateNameFieldMeta: TemplateFormComponentMeta<TemplateFormNameFieldMeta> = {
  component: TemplateFormNameField,
  MetadataFactory: (field, disableEdit) => ({
    title: DomPurify.sanitize(field.display_name || ''),
    description: field.description!,
    logo: field.logo!,
    logoDarkMode: field.logo!,
    label: DomPurify.sanitize(field.display_name || ''),
    required: true,
    placeholder: field.display_name,
    disabled: disableEdit || !!field.disabled
  }),
  ValidationSchemaFactory: () => Yup.object().shape({})
};
